import { FolderTree, Database, Library, Workflow, Bot, Box, RadioTower } from 'lucide-react';
import { useResource } from './useResource.js';
// Registry navIcon keys → lucide components. Unknown keys fall back to a generic
// box so a newly-shipped product never renders a blank slot.
const ICONS = {
    'folder-tree': FolderTree,
    database: Database,
    library: Library,
    workflow: Workflow,
    bot: Bot,
    'radio-tower': RadioTower,
};
export function iconForKey(key) {
    return (key && ICONS[key]) || Box;
}
export async function loadApps(registryUrl, fetcher = fetch) {
    const response = await fetcher(registryUrl, { credentials: 'include' });
    if (!response.ok)
        throw new Error(`App registry returned ${response.status}`);
    const data = await response.json();
    return (data.products ?? []).map((product) => ({
        id: product.productId,
        label: product.displayName,
        href: product.url,
        iconKey: product.navIcon,
    }));
}
// The tenant's launchable products, from the application registry — the single
// source the dashboard launcher and every product's app-rail share, so the rail
// reads identically on every tenant surface. Credentialed: the parent-domain
// cookie carries the session cross-origin. Failures stay explicit so a broken
// registry cannot look like a tenant with no products.
// ponytail: a plain fetch on mount — no cache/dedupe; add SWR if the rail visibly
// re-flashes across app hops.
export function useApps(registryUrl) {
    return useResource(() => registryUrl ? loadApps(registryUrl) : Promise.resolve([]), [registryUrl ?? '']);
}
